// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"c160baab","79":"fd9470e5","200":"a5984140","258":"a5984140","376":"ce143a6b","415":"08ae8678","530":"a5984140","638":"983f9983","699":"08ae8678"}[chunkId] + ".chunk.css";
};